import {
  AutoAwesome,
  Close,
  Person,
} from "@mui/icons-material";
import {
  Avatar,
  Card,
  CardActionArea,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { useEmployeeTerminology } from "../../../utils/terminology";

interface NewEmployeeDialogProps {
  open: boolean;
  onClose: () => void;
  onCreateFromScratch: () => void;
  onBrowseTemplates: () => void;
}

const NewEmployeeDialog: React.FC<NewEmployeeDialogProps> = ({
  open,
  onClose,
  onCreateFromScratch,
  onBrowseTemplates,
}) => {
  const { employee: employeeText, employeeLower } = useEmployeeTerminology();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Typography variant="h6">Create New {employeeText}</Typography>
        <IconButton onClick={onClose} size="small">
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={12} sm={6}>
            <Card
              variant="outlined"
              sx={{
                height: "100%",
                transition: "all 0.2s",
                "&:hover": {
                  borderColor: "primary.main",
                  bgcolor: "action.hover",
                },
              }}
            >
              <CardActionArea
                onClick={() => {
                  onClose();
                  onCreateFromScratch();
                }}
                sx={{ height: "100%", p: 2 }}
              >
                <CardContent sx={{ p: 0 }}>
                  <Stack spacing={2} alignItems="center" textAlign="center">
                    <Avatar sx={{ bgcolor: "primary.main", width: 56, height: 56 }}>
                      <Person sx={{ fontSize: 32 }} />
                    </Avatar>
                    <Typography variant="h6">Create from Scratch</Typography>
                    <Typography variant="body2" color="text.secondary">
                      Start with a blank {employeeLower} and define the role,
                      name, and personality yourself using AI generation.
                    </Typography>
                  </Stack>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Card
              variant="outlined"
              sx={{
                height: "100%",
                transition: "all 0.2s",
                "&:hover": {
                  borderColor: "primary.main",
                  bgcolor: "action.hover",
                },
              }}
            >
              <CardActionArea
                onClick={() => {
                  onClose();
                  onBrowseTemplates();
                }}
                sx={{ height: "100%", p: 2 }}
              >
                <CardContent sx={{ p: 0 }}>
                  <Stack spacing={2} alignItems="center" textAlign="center">
                    <Avatar sx={{ bgcolor: "primary.main", width: 56, height: 56 }}>
                      <AutoAwesome sx={{ fontSize: 32 }} />
                    </Avatar>
                    <Typography variant="h6">Use Pre-Built</Typography>
                    <Typography variant="body2" color="text.secondary">
                      Choose from pre-built {employeeLower}s with
                      professional headshots and optimized prompts.
                    </Typography>
                  </Stack>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default NewEmployeeDialog;
